module.exports = __webpack_public_path__ + "img/john-harald-knutsson-l.365568c9.jpg";